import session from 'lib/session';
import { createReducer, success } from 'redux/shelf';
import { del, get, post, put, search } from 'redux/shelf/api';

export const actions = {
  fetchSuggestions: search.get`autocomplete`((suggestions) => ({
    suggestions,
  })),
  fetchProducts: search.post`search`(),
  fetchCollectionProducts: search.post`smart-collection/:slot`(
    ({ meta, items = [] }) => ({ products: { meta, items } })
  ),
};

export const productsActions = {
  create: post`products/${session.getMerchant}/pinned`(),
  remove: del`products/${session.getMerchant}/pinned/:id`(),
  fetch: get`products/${session.getMerchant}/pinned/:id`((p) => ({
    entity: p[0] || p,
  })),
  update: put`products/${session.getMerchant}/pinned`(),
  fetchList: get`products/${session.getMerchant}/pinned`(),
  importFile: post`products/${session.getMerchant}/pinned/upload`(),
};

export const collectionsActions = {
  create: post`smart-collections/${session.getMerchant}/pinned`(),
  remove: del`smart-collections/${session.getMerchant}/pinned/:id`(),
  fetch: get`smart-collections/${session.getMerchant}/pinned/:id`((p) => ({
    entity: p[0] || p,
  })),
  update: put`smart-collections/${session.getMerchant}/pinned/:id`(() => {}),
  fetchList: get`smart-collections/${session.getMerchant}/pinned`(),
  importFile: post`smart-collections/${session.getMerchant}/pinned/upload`(),
};

export const loadMoreProducts = search.get`search`();
export const loadMoreCollectionProducts = search.post`smart-collection/:slot`();

const toArray = (collection) =>
  Object.keys(collection).map((k) => collection[k]);

export const reducer = createReducer(
  [
    ...toArray(productsActions),
    ...toArray(collectionsActions),
    ...toArray(actions),
  ],
  {
    [success(loadMoreProducts)]: (s, { payload }) => ({
      ...s,
      products: {
        meta: payload.meta,
        items: [...s.products.items, ...payload.items],
      },
    }),
    [success(loadMoreCollectionProducts)]: (s, { payload }) => {
      return {
        ...s,
        products: {
          meta: payload.meta,
          items: [...s.products.items, ...payload.items],
        },
      };
    },
    [success(actions.fetchProducts)]: (s, { payload }) => {
      return {
        ...s,
        products: {
          meta: payload.meta,
          items: !!payload.meta.offset
            ? [...s.products.items, ...payload.items]
            : [...payload.items],
        },
      };
    },
    [productsActions.remove]: (s, { meta }) => ({
      ...s,
      entities: s.entities.filter(({ id }) => id !== meta.id),
    }),
    [collectionsActions.remove]: (s, { meta }) => ({
      ...s,
      entities: s.entities.filter(
        ({ collectionID }) => collectionID !== meta.id
      ),
    }),
  }
);
